import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import { GET_COUNTRIES, GET_EDUCATIONAL_STATUSES, GET_FORMS_OF_EDUCATION, GET_GRADE_OPTIONS, GET_GRADE_WEIGHT, GET_TYPES_STUDY_SESSIONS } from "./types";


//ВСЕ СПРАВОЧНИКИ

// <---- ВЕСА ОЦЕНОК ---->
export const getGradeWeight = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/weight`);
    dispatch({ type: GET_GRADE_WEIGHT, payload: data });
  } catch (error) {
    console.error('Error in directory action:', error);
  }
};

export const updateGradeWeight = (params, id) => async (dispatch, getState) => {
  try {
    await api.put(`/weight/${id}`, params);
    await dispatch(getGradeWeight());
    createNotification('success', 'Успешно');
  } catch (error) {
    console.error('Error in directory action:', error);
    createNotification('error', error.response?.data?.error || 'Не удалось изменить запись');
  }
}

export const createGradeWeight = (data) => async (dispatch, getState) => {
  try {
    await api.post(`/weight`, data);
    createNotification('success', 'Успешно');
    await dispatch(getGradeWeight());
  } catch (error) {
    console.error('Error in directory action:', error);
    createNotification('error', error.response?.data?.error || "Не удалось создать запись");
  }
};
export const deleteGradeOption = (groupsId) => async (dispatch, getState) => {
  try {
    await api.delete(`/weight/${groupsId}`);
    createNotification('success', 'Успешно');
    await dispatch(getGradeWeight());
  } catch (error) {
    console.error('Error in directory action:', error);
    createNotification('error', error.message);
  }
};

// <----  ВАРИАНТЫ ОЦЕНОК ---->

export const getGradeOptions = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/grade_value`);
    dispatch({ type: GET_GRADE_OPTIONS, payload: data.items ?? data });
  } catch (error) {
    console.error('Error in directory action:', error);
  }
};

export const updateGradeOptions = (params) => async (dispatch, getState) => {
  try {
    await api.put(`/grade_value/${params.valid}`, params);
    createNotification('success', 'Успешно');
    await dispatch(getGradeOptions());
    return true;
  } catch (error) {
    console.error('Error in directory action:', error);
    createNotification('error', error.response?.data?.error || error.message || 'Произошла ошибка');
    return false;
  }
}

export const createGradeOptions = (data) => async (dispatch, getState) => {
  try {
    await api.post(`/grade_value`, data);
    createNotification('success', 'Успешно');
    await dispatch(getGradeOptions());
    return { success: true };
  } catch (error) {
    console.error('Error in directory action:', error);
    const message = error.response?.data?.detail || error.response?.data?.error || error.message || 'Произошла ошибка';
    createNotification('error', message);
    return { success: false, error: message };
  }
};

export const deleteGradeOptions = (valid) => async (dispatch, getState) => {
  try {
    await api.delete(`/grade_value/${valid}`);
    createNotification('success', 'Успешно');
    await dispatch(getGradeOptions());
  } catch (error) {
    console.error('Error in directory action:', error);
    createNotification('error', error.response?.data?.detail || error.response?.data?.error || error.message || 'Произошла ошибка');
  }
};


// <----  ТИПЫ УЧЕБНЫХ ЗАНЯТИЙ ---->

export const getTypesStudySessions = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/types_training`);
    dispatch({ type: GET_TYPES_STUDY_SESSIONS, payload: data });
  } catch (error) {
    console.error('Error in directory action:', error);
  }
};

export const updateTypesStudySessions = (params, id) => async (dispatch, getState) => {
  try {
    await api.put(`/types_training/${params.typeid}`, params);
    await dispatch(getTypesStudySessions());
    createNotification('success', 'Успешно');
  } catch (error) {
    console.error('Error in directory action:', error);
    createNotification('error', 'Не удалось изменить запись');
  }
}

export const createTypesStudySessions = (data) => async (dispatch, getState) => {
  try {
    await api.post(`/types_training`, data);
    await dispatch(getTypesStudySessions());
    createNotification('success', 'Успешно');
  } catch (error) {
    console.error('Error in directory action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};

// <---- УЧЕБНЫЕ СТАТУСЫ ---->

export const getEducationalStatuses = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/status`);
    dispatch({ type: GET_EDUCATIONAL_STATUSES, payload: data });
  } catch (error) {
    console.error('Error in directory action:', error);
  }
};

export const updateEducationalStatuses = (params, closeModal) => async (dispatch, getState) => {
  try {
    await api.put(`/status/${params.xp_key}`, params);
    await dispatch(getEducationalStatuses());
    createNotification('success', 'Успешно');
    closeModal?.();
  } catch (error) {
    console.error('Error in directory action:', error);
    createNotification('error', "Не удалось изменить запись");
  }
}

export const createEducationalStatuses = (data, closeModal) => async (dispatch, getState) => {
  try {
    await api.post(`/status`, data);
    createNotification('success', 'Успешно');
    await dispatch(getEducationalStatuses());
    closeModal?.();
  } catch (error) {
    console.error('Error in directory action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};

export const deleteEducationalStatuses = (groupsId) => async (dispatch, getState) => {
  try {
    await api.delete(`/status/${groupsId}`);
    await dispatch(getEducationalStatuses());
    createNotification('success', 'Успешно');
  } catch (error) {
    console.error('Error in directory action:', error);
    createNotification('error', "Не удалось удалить запись");
  }
};


// <---- СТРАНЫ ---->

export const getCountries = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/library/location/countries`);
    dispatch({ type: GET_COUNTRIES, payload: data });
  } catch (error) {
    console.error('Error in directory action:', error);
  }
};

// export const updateCountries= (params) => async (dispatch, getState) => {
// await dispatch(checkAndUpdateToken());
// if (getState().auth.token) {

//     const response = await fetch(`${API_BASE_URL}/status/${params.xp_key}`, {//TODO
//       method: "PUT",
//             body: JSON.stringify(params),
//             ...buildDefaultHeaders(getState),
//       });
//       if (response.ok) {      
//         await dispatch(getCountries());
//       }
// };
// }

// export const createCountries = (data) => async (dispatch, getState) => {
//   await dispatch(checkAndUpdateToken());
//   if (getState().auth.token) {
//     const response = await fetch(`${API_BASE_URL}/status`, {//TODO
//       method: "POST",
//       body: JSON.stringify(data),
//       ...buildDefaultHeaders(getState),
//     });
//     if (response.ok) {
//       createNotification('success', 'Успешно');
//       await dispatch(getCountries());
//     } else createNotification('error', "Не удалось создать запись");
//   }
// };

// export const deleteCountries = (groupsId) => async (dispatch, getState) => {
//   await dispatch(checkAndUpdateToken());
//   if (getState().auth.token) {
//     const response = await fetch(`${API_BASE_URL}/status/${groupsId}`, {
//       method: "DELETE",
//       ...buildDefaultHeaders(getState),
//     });
//     if (response.ok) {
//       createNotification('success', 'Успешно');
//       await dispatch(getCountries());
//     }
//   }
// };


// <---- ФОРМЫ ОБУЧЕНИЯ ---->

export const getFormOfEducation = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/study_forms`);
    dispatch({ type: GET_FORMS_OF_EDUCATION, payload: data });
  } catch (error) {
    console.error('Error in directory action:', error);
  }
};

export const updateFormOfEducation = ({ id, name }, closeModal) => async (dispatch, getState) => {
  try {
    await api.put(`/study_forms/${id}`, { name });
    createNotification('success', 'Успешно');
    closeModal();
    await dispatch(getFormOfEducation());
  } catch (error) {
    console.error('Error in directory action:', error);
    const errorMessage = error.message || 'Не удалось изменить запись';
    createNotification('error', errorMessage);
  }
}

export const createFormOfEducation = ({ name }, closeModal) => async (dispatch, getState) => {
  try {
    await api.post(`/study_forms`, { name });
    createNotification('success', 'Успешно');
    closeModal();
    await dispatch(getFormOfEducation());
  } catch (error) {
    console.error('Error in directory action:', error);
    const errorMessage = error.message || 'Не удалось создать запись';
    createNotification('error', errorMessage);
  }
};

export const deleteFormOfEducation = (groupsId) => async (dispatch, getState) => {
  try {
    await api.delete(`/study_forms/${groupsId}`);
    await dispatch(getFormOfEducation());
    createNotification('success', 'Успешно');
  } catch (error) {
    console.error('Error in directory action:', error);
    createNotification('error', "Не удалось удалить запись");
  }
};

